<template>
  <div>
    <LoadingContainer v-if="loading"/>

    <FormLayout
        v-else
        :initial="contentJob.attributes"
        :errors="errors"
        :company-id="contentJob.attributes.company_id"
        :content-job-regions="contentJobRegions"
        :edit="true"
        :url="portal.attributes.base_url + '/' + contentJob.attributes.path"
        @submit="submit"
    />
  </div>
</template>

<script>
import http from '@/http'
import notify from '@/notify'
import FormLayout from '../../../../../../../components/Administration/ContentJobs/Layouts/Form'
import LoadingContainer from '../../../../../../../components/Layout/LoadingContainer'

export default {
  components: {LoadingContainer, FormLayout},

  props: {
    portal: {
      required: true
    },

    blockDrivers: {
      required: true
    },

    layoutCategories: {
      required: true
    }
  },

  data() {
    return {
      contentJob: null,
      contentJobRegions: null,
      loading: true,

      errors: {}
    }
  },

  mounted() {
    this.load()
  },

  methods: {
    load() {
      Promise.all([
        http.get('/api/v2/content-jobs/' + this.$route.params.contentJobId),
        http.get('/api/v2/content-job-regions', {'filter[portal_id]': this.portal.id, page_size: 100})
      ]).then(responses => {
        this.contentJob = responses[0].data.data

        this.contentJobRegions = responses[1].data.data

        this.loading = false
      })
    },

    submit(data) {
      http.put('/api/v2/content-jobs/' + this.$route.params.contentJobId, data)
          .then(response => {
            notify.success('The content job was saved')

            this.contentJob = response.data.data

            this.errors = {}
          })
          .catch(error => {
            if (error.response.status === 422) {
              this.errors = error.response.data.errors
            }

            throw error
          })
    },
  }
}
</script>
